const getBrowserInfo = () => {
  if (typeof navigator === 'undefined') return "Unknown";
  
  const userAgent = navigator.userAgent;
  let browser = "Unknown";
  
  if (userAgent.includes("Firefox")) {
    browser = "Firefox";
  } else if (userAgent.includes("Edg/")) {
    browser = "Edge";
  } else if (userAgent.includes("OPR") || userAgent.includes("Opera")) {
    browser = "Opera";
  } else if (userAgent.includes("Chrome")) {
    browser = "Chrome";
  } else if (userAgent.includes("Safari")) {
    browser = "Safari";
  } else if (userAgent.includes("Trident") || userAgent.includes("MSIE")) {
    browser = "Internet Explorer";
  }
  
  return browser;
};

const getDeviceInfo = () => {
  if (typeof navigator === 'undefined') return "Unknown";
  
  const userAgent = navigator.userAgent;
  
  // Check for mobile devices
  if (/Android/i.test(userAgent)) {
    return "Android";
  } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
    return (/iPad/i.test(userAgent)) ? "iPad" : (/iPod/i.test(userAgent) ? "iPod" : "iPhone");
  } else if (/Windows Phone/i.test(userAgent)) {
    return "Windows Phone";
  }
  
  // Check for desktop operating systems
  if (/Windows/i.test(userAgent)) {
    return "Windows";
  } else if (/Macintosh/i.test(userAgent)) {
    return "Mac";
  } else if (/Linux/i.test(userAgent)) {
    return "Linux";
  }
  
  return "Unknown";
};

export const collectUserMetadata = async () => {
  try {
    // Fetch country information
    const countryResponse = await fetch("https://ipapi.co/json/");
    const countryData = await countryResponse.json();
    
    return {
      country: countryData.country_name || "Unknown",  // Full country name
      countryCode: countryData.country || "Unknown",   // Two-letter country code
      device: getDeviceInfo(),
      browser: getBrowserInfo(),
      url: window.location.href,
      referrer: document.referrer,
    };
  } catch (error) {
    console.error("Error fetching country data:", error);
    return {
      country: "Unknown",
      countryCode: "Unknown",
      device: getDeviceInfo(),
      browser: getBrowserInfo(),
      url: window.location.href,
      referrer: document.referrer,
    };
  }
};